const ngPreview = ['$lazyScripts', function ($lazyScripts) {
    return {
        /**
         * @param $scope
         * @param $item
         * @param $params {{ ngPreview: string }}
         */
        link: function ( $scope, $item, $params ) {
            if ( $params.ngPreview.length === 0 ) {
                return false;
            }
            let handler = ('ontouchstart' in document.documentElement ? "touchmove" : "mouseenter");

            $item[0].addEventListener( handler, (e) => {
                $item[0].parentNode.dataset.hover = "true";
                if ( $item[0].parentNode.querySelector('video') === null ) {
                    this.delete($scope);
                    $scope.preview = this.create($params.ngPreview);
                    $item[0].parentNode.prepend ( $scope.preview );
                }
            }, { passive: true });

            if ( handler === 'mouseenter') {
                $item[0].addEventListener('mouseleave', () => {
                    delete $item[0].parentNode.dataset.hover;
                    this.delete($scope);
                }, { passive: true });
            }
        },
        create: function ($src) {
            const video = document.createElement('video');

            if ($src.includes(".m3u8")) {
                $lazyScripts.loadHls().then(() => {
                    if (!Hls.isSupported()) {
                        video.setAttribute('src', $src);
                        return;
                    }

                    const hlsInstance = new Hls({
                        maxMaxBufferLength: 15,
                    });
                    setTimeout(() => {
                        hlsInstance.loadSource($src);
                        hlsInstance.attachMedia(video);
                    }, 50);
                });
            } else {
                video.setAttribute('src', $src);
            }

            video.setAttribute('playsinline', "true");
            video.setAttribute('webkit-playsinline', "true");
            video.setAttribute('autoplay', "autoplay");
            video.setAttribute('muted', "muted");
            video.setAttribute('loop', "loop");

            video.addEventListener('loadeddata', function() {
                video.dataset.loaded = "true";
                video.volume = 0.0;
                video.muted = true;
            }, {passive: true});

            return video;
        },
        delete: function ($scope) {
            if ( $scope.hasOwnProperty('preview') === true ) {
                $scope.preview.remove();
                delete($scope.preview);
            }
        }
    }
}];

export default ngPreview;
